import { Component, h } from 'preact';
import { PreactHTMLConverter } from 'preact-html-converter';
import OtherCandidate from './OtherCandidate';

import { getStatewideDisplay, sort_candidates_by_party } from '../utils/election-utils';

const converter = PreactHTMLConverter();

class Contest extends Component {
  constructor() {
    super();

    this.state = {
      viewAllCandidates: false,
    };
    this.onViewableToggle = this.onViewableToggle.bind(this);
  }

  onViewableToggle() {
    this.setState(prevState => ({
      viewAllCandidates: !prevState.viewAllCandidates, // set viewAllCandidates to what is wasn't before
    }));
  }

  render(
    {
      flag,
      race,
      statewideRace,
      visibleCandidateCount,
      renderCandidate,
    },
    { viewAllCandidates }
  ) {

    let candidacies;

    const IsFlagged = flag ? true : false;
    const IsStatewide = statewideRace ? true : false;
    const IsRepTarget = IsFlagged && flag.rep_target ? true : false;
    const IsDemTarget = IsFlagged && flag.dem_target ? true : false;

    if (race && !IsStatewide) {
       candidacies = sort_candidates_by_party(race[0].candidacies);
    }
    else if (race && IsStatewide) {
      candidacies = sort_candidates_by_party(race.candidacies);
    }

    const caption = getStatewideDisplay(race);

    return (
      <div class="seat">
        {statewideRace && <h3 class="seat__title">{caption}</h3>}

        {IsFlagged == true && (
          <div class="seat__flag">
            <p class="office__flag">
              <span class="gold-star">★</span>Race to watch
              {IsDemTarget == true && (
                <span
                  class="pill pill--target pill--dem"
                  title="Target for Democrats"
                >
                  {'DEM TARGET'}
                </span>
              )}
              {IsRepTarget == true && (
                <span
                  class="pill pill--target pill--rep"
                  title="Target for Republicans"
                >
                  {'GOP TARGET'}
                </span>
              )}
            </p>
            <p class="seat__flag__text">{converter.convert(flag.prose)}</p>
          </div>
        )}

        <div class="seat__race seat__race">
          <div class="race">
            {/* <h4 class="race__title">Democrat</h4> */}
            <table class="race__candidates">
              <thead>
                <tr>
                  {' '}
                  <th scope="col" class="race__candidate-header" colspan="2">
                    Candidates{' '}
                  </th>{' '}
                </tr>
              </thead>
              <tbody>
                {candidacies.map((candidate: any, idx: any) =>
                  renderCandidate(candidate, idx, viewAllCandidates)
                )}
                {candidacies.length > visibleCandidateCount && (
                  <OtherCandidate
                    isViewable={!viewAllCandidates}
                    candidateCount={candidacies.length}
                    onClick={() => {
                      this.onViewableToggle();
                    }}
                  />
                )}
              </tbody>

              {candidacies.length > visibleCandidateCount && viewAllCandidates && (
                <tr class="candidate race__candidate-row">
                  <td
                    class="candidate__cell candidate__party t-align-center"
                    onClick={() => {
                      this.onViewableToggle();
                    }}
                  >
                    <svg class="icon icon-angle-up">
                      <use xlinkHref="#icon-angle-up" />
                    </svg>
                  </td>
                  <th class="candidate__cell candidate__name">
                    <button
                      onClick={() => {
                        this.onViewableToggle();
                      }}
                    >
                      Show fewer candidates{' '}
                    </button>
                  </th>
                </tr>
              )}
            </table>
          </div>
        </div>
      </div>
    );
  }
}

Contest.defaultProps = {
  statewideRace: false,
  visibleCandidateCount: 4,
};

export default Contest;
